<template>
  <section class="relative">
    <div class="faq-bg bg-no-repeat bg-center md:bg-bottom bg-cover absolute h-70v md:h-screen md:top-0 md:bottom-0 left-0 right-0 md:right-2 -z-1"/>
    <search-bar class="pt-24 md:pt-48 px-0 md:px-auto" :text="page.ondertitel"/>
    <section class="container flex justify-center flex-wrap mt-32 sm:mt-0 py-12">
      <div v-for="n in cols" :key="n" :class="`w-full sm:w-8/12 md:w-${12/cols}/12 h-full flex flex-col`">
        <div v-for="item in chunkedFaqs[n - 1]" :key="item.permalink" class="mb-4">
          <nuxt-link :to="{name: 'faq-slug', params: {slug: item.permalink}}" class="no-underline">
            <h2 class="faq-item rounded-12p shadow-2xl text-heading text-white mx-3 px-3 pt-5 pb-6">
              {{ item.question }}
            </h2>
          </nuxt-link>
        </div>
      </div>
    </section>
    <call-to-action
      title="Euhhh...?"
      content="Heb je een brandende vraag en stond hij hier niet tussen?"
      class="mt-16 mb-24"
    />
  </section>
</template>

<script>
import {mapState} from 'vuex';
import CallToAction from '~/components/CallToAction';
import SearchBar from '~/components/faq/SearchBar';
import page from '~/plugins/mixins/page';

export default {
  components: {
    CallToAction,
    SearchBar,
  },
  mixins: [page],
  data() {
    return {
      cols: 4,
      noResults: false,
    };
  },
  computed: {
    ...mapState({
      faqs: state => state.faqs.questions,
    }),
    chunkedFaqs() {
      if (this.faqs) {
        const chunkSize = Math.ceil(this.faqs.length / this.cols);
        const chunkedFaqs = [];

        for (let i = 0; i < this.faqs.length; i += chunkSize) {
          chunkedFaqs.push(this.faqs.slice(i, i + chunkSize));
        }
        return chunkedFaqs;
      }
      return [];
    },
  },
  created() {
    if (!this.$route.params.noSearch) {
      this.$store.dispatch('faqs/getQuestions');
    }
  },
};
</script>

<style lang="scss" scoped>
.faq-item {
  background: url("~assets/img/bg-linkitems.svg") no-repeat top / cover;
}
.faq-bg {
  background-image: url("~assets/img/bg-faq.svg");
}
</style>
